import { colors } from '@puzzlio/tokens';
import type { HowToPlay } from '@puzzlio/core';

export const howToPlay: HowToPlay = {
  game: 'mosaic',
  rules: () => [
    { kind: 'line', line: 'Shade the cells to uncover a picture.' },
    {
      kind: 'bullets',
      items: [
        'Numbers above each column show how many cells to shade.',
        'Numbers next to each row show how many cells to shade.',
        'A “3 1” means a block of 3, a gap, then a block of 1.',
      ],
    },
  ],
  controlNotes: ({ showsMiniBoard }) => (showsMiniBoard ? ['Double tap the mini-board to toggle zoom mode.'] : []),
  cycle: [
    { fill: colors['white'] },
    { fill: colors['purple-default'] },
    { fill: colors['white'], glyph: 'cross' },
    { fill: colors['white'] },
  ],
};
